import React from "react";
import { TablePaginationProps } from "../tableTypes";
import MuiTablePagination from "@material-ui/core/TablePagination";
import translations from "translations";

const TablePagination: React.FC<TablePaginationProps<object>> = ({
  tableProps,
  TablePaginationActions,
  config,
  tableInstance,
}) => {
  const {
    gotoPage,
    setPageSize,
    pageCount,
    pageOptions,
    rows,
    state: { pageIndex, pageSize },
  } = tableInstance;

  return (
    <>
      {config.pagination === true && (
        <MuiTablePagination
          component="div"
          // count={rows.length}
          //   count={100}
          count={rows.length}
          rowsPerPage={pageSize}
          page={pageIndex}
          //   page={pageCount}
          labelDisplayedRows={() => null}
          rowsPerPageOptions={tableProps?.rowsPerPageOptions}
          labelRowsPerPage={translations.globals.table.rowsPerPage}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onChangePage={(e, page) => {
            gotoPage(page);
          }}
          onChangeRowsPerPage={(e) => {
            setPageSize(Number(e.target.value));
          }}
          ActionsComponent={(actionProps) =>
            TablePaginationActions({
              ...actionProps,
              disable: tableProps?.disablePagination ?? pageSize > rows.length,
              pageOptions,
              pageCount,
            })
          }
        />
      )}
    </>
  );
};

export default TablePagination;
